<template>
  <div>
    <!-- 胰岛素敏感指数(HOMA-ISI)，胰岛素抵抗指数(HOMA-IR)，胰岛素分泌指数(HOMA-β)。 -->
    <!-- HOMA-IR=(空腹血糖×空腹胰岛素)/22.5；HOMA-β=20×空腹胰岛素/(空腹血糖-3.5)；HOMA-ISI=1/(FPG×FINS)。 -->
    <el-card>
    <el-form :inline="true" :model="HOMA" class="demo-form-inline">
      <el-form-item label="空腹血糖">
        <el-input
          v-model.number="HOMA.FPG"
          type="number"
          :step="0.01"
          placeholder="空腹血糖 mmol/L"
        ></el-input>
      </el-form-item>
      <el-form-item label="空腹胰岛素">
        <el-input
          v-model.number="HOMA.FINS"
          type="number"
          :step="0.01"
          placeholder="空腹胰岛素 μU/mL"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <p> 胰岛素敏感指数(HOMA-ISI):{{ HOMAISI}}</p>
    <p>胰岛素抵抗指数(HOMA-IR):{{ HOMAIR }}</p>
    <p>胰岛素分泌指数(HOMA-β):{{ HOMAβ }}</p>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      HOMA: {
        FPG: "",
        FINS: "",
      },
      HOMAIR: "",
      HOMAβ: "",
      HOMAISI: "",
    };
  },
  methods: {
    onSubmit() {
      this.HOMACalculator();
      console.log("submit!");
      console.log(this.HOMA);
      console.log(this.HOMAIR);
      console.log(this.HOMAβ);
    },
    HOMACalculator(){
      this.HOMAIR = (this.HOMA.FPG * this.HOMA.FINS) / 22.5;
      this.HOMAβ = 20 * this.HOMA.FINS / (this.HOMA.FPG - 3.5);
      this.HOMAISI = 1 / (this.HOMA.FPG * this.HOMA.FINS);
      // 保留两位小数
      this.HOMAIR = this.HOMAIR.toFixed(2);
      this.HOMAβ = this.HOMAβ.toFixed(2);
      this.HOMAISI = this.HOMAISI.toFixed(2);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Calculator.vue